// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".signup-back-button[data-v-053850a4]{left:2rem;top:-.4rem}@media (min-width:1024px){.signup-back-button[data-v-053850a4]{top:4rem}}@media (min-width:768px){.signup-back-button[data-v-053850a4]{z-index:70}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
